<template>
  <Layout>
    <template v-slot:title>Historial de Visualización</template>
    <VideosList>
      Todavía no has visto ningún vídeo.
    </VideosList>
  </Layout>
</template>

<script>
import Layout from '@/layouts/MainLayout'
import VideosList from '@/components/VideosList'

export default {
  components: { Layout, VideosList },

  mounted() {
    this.$store.dispatch('videos/fetchVideosUserHistory')
  },
}
</script>
